import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetGuests } from 'api-hooks/guest';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
interface GuestSelectProps extends SelectProps {}

export default function GuestSelect(props: GuestSelectProps) {
  const { t } = useTranslation();
  const {
    label = t('common:agent'),
    placeholder = t('common:select_guest'),
    ...rest
  } = props;
  const query = useGetGuests({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...rest}
      data={data}
      label={label}
      placeholder={placeholder}
      disabled={query.isLoading || props.disabled}
    />
  );
}
